export default "__VITE_ASSET__CgvO5PLj__"